import * as Connector from 'shared/connectors/notificationConnector';
import { NOTIFICATION } from 'store/types';

const init = () => ({
  type: NOTIFICATION.GET_EMPLOYEES_INIT,
});

export const success = data => ({
  type: NOTIFICATION.GET_EMPLOYEES_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: NOTIFICATION.GET_EMPLOYEES_FAILURE,
});

const getEmployees = () => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getEmployees();
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getEmployees;
